import React, { useEffect, useState } from "react";
// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React context
import { useMaterialUIController, setLayout } from "context";
import Sidenav from "examples/Sidenav";
import { setMiniSidenav, setOpenConfigurator } from "context";
import { useAuth } from "utils/AuthContext";
import routes from "routes";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function DashboardLayout({ children }) {
  const navigate = useNavigate();

  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const { user: authUser, logout: authLogout } = useAuth();

  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const displayData = authUser;

  if (displayData)
    return (
      <MDBox
        sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
          p: 3,
          position: "relative",

          [breakpoints.up("xl")]: {
            marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
            transition: transitions.create(["margin-left", "margin-right"], {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.standard,
            }),
          },
        })}
      >
        <Sidenav
          // color={"red"}
          brand={"https://tnclimatechangemission.in/images/logo.svg"}
          brandName="CMGFP"
          routes={routes}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
          user={displayData}
        />
        <DashboardNavbar user={displayData} />
        {children}
      </MDBox>
    );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
